import React, { FC, useState, createContext } from 'react';

type SidebarContextType = {
  sidebarToggle: boolean;
  collapsed: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  toggleCollapsed: () => void;
  setCollapsed?: (value: boolean) => void;
};

export const SidebarContext = createContext<SidebarContextType>(
  {} as SidebarContextType
);

export const SidebarProvider: FC<React.PropsWithChildren<object>> = ({
  children,
}) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  return (
    <SidebarContext.Provider
      value={{
        sidebarToggle,
        toggleSidebar,
        closeSidebar,
        toggleCollapsed,
        collapsed,
        setCollapsed,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
